import React from "react";
import { useFunnelNavigation } from "../../hooks/useFunnelNavigation";
import { StepHeader } from "../common/StepHeader";
import { Footer } from "../common/Footer";

export function Testimonial({ config }) {
  const { nextStep } = useFunnelNavigation();

  return (
    <div className="px-4">
      <StepHeader title={config.title} subtitle={config.subtitle} />

      <div className="space-y-6">
        {/* Testimonial Card */}
        <div className="bg-white rounded-2xl p-4 space-y-2">
          {/* User Info */}
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900">{config.userName}</h3>
              <p className="text-sm text-green-500">{config.achievement}</p>
            </div>

            {/* Rating Stars moved to right */}
            <div className="flex gap-0">
              {[...Array(5)].map((_, index) => (
                <svg
                  key={index}
                  className="w-5 h-5 text-orange-400"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                </svg>
              ))}
            </div>
          </div>

          {/* Testimonial Text */}
          <p className="text-sm text-gray-600">{config.testimonial}</p>

          {/* Before/After Images */}
          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-2">
              <img
                src={config.beforeImage}
                alt="Before"
                className="w-full h-64 object-cover rounded-lg"
              />
            </div>
            <div className="space-y-2">
              <img
                src={config.afterImage}
                alt="After"
                className="w-full h-64 object-cover rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>

      <Footer onClick={nextStep}>{config.buttonText || "Continue"}</Footer>
    </div>
  );
}
